var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 20C7.46944 19.9974 6.96121 19.7862 6.58511 19.4119C6.20901 19.0377 5.99525 18.5305 5.99 18H9.99C9.99211 18.2674 9.94113 18.5325 9.84 18.78C9.71068 19.0767 9.51267 19.3385 9.2623 19.5437C9.01193 19.7488 8.71637 19.8915 8.4 19.96H8.353C8.23682 19.9842 8.11865 19.9976 8 20ZM16 17H0V15L2 14V8.5C1.94732 7.08912 2.26594 5.68913 2.924 4.44C3.24784 3.86727 3.68943 3.36971 4.21965 2.98015C4.74987 2.59058 5.35666 2.31787 6 2.18V0H10V2.18C12.579 2.794 14 5.038 14 8.5V14L16 15V17Z",
    fill: "#A19F9D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector1.de2c6575ae6c87c2dd740438d96246c9.svg";
export { ForwardRef as ReactComponent };